<!--
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-30 17:39:10
 * @LastEditTime: 2019-10-22 03:39:33
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="activityShare">
    <barrage v-if="isShowBarrage"
             :top="50"
             :data="barrageArr"></barrage>
    <div class="top_view">
      <img class="share_back"
           :src="picUrl.shareBack"
           alt="">
      <img class="share_flag"
           :src="picUrl.shareFlag"
           alt="">
      <h4 class="share_flag_text">
        战力池 {{myAccount.remainAmount}}
      </h4>
      <div class="share_rule_view"
           @click="showRule(true)"></div>
      <div class="content_box">
        <img class="share_box" :src="picUrl.shareBox">
        <h4 class="reward_money"><span>我的战力</span>{{myAccount.myBountyTotal}}</h4>
        <div class="freeze_money">冻结战力：<span>{{myAccount.myFreezeTotal}}</span></div>
        <!-- 如果在app中打开，隐藏提现按钮，李林要求 -->
        <div v-if="deviceType === 0" class="share_withdraw"
             @click="shareWithdraw">兑换 &gt;</div>
        <img class="share_ques"
             @click="clickFreezeBtn"
             :src="picUrl.shareQuestion"
             alt="">
        <div v-if="nowActivityType == 1"
             class="share_btn_disable">活动未开始</div>
        <div v-else-if="nowActivityType == 2"
             class="share_btn_disable">活动已结束</div>
        <img v-else
             data-clipboard-action="copy"
             class="share_btn"
             :src="shareBtnUrl"
             ref="copy"
             :data-clipboard-text="shareLink"
             @click="clickShareBtn"
             alt="">
        <p class="toActivityList"><router-link to="/activityDetail">前往活动星球</router-link></p>
      </div>

    </div>
    <div class="record">
      <div class="navi_bar">
        <div class="navi_bar_item"
             @click="navbarActiveIndex = 0">
          <div :class="{'active':navbarActiveIndex == 0}">战力记录</div>
        </div>
        <div class="navi_bar_item"
             @click="navbarActiveIndex = 1">
          <div :class="{'active':navbarActiveIndex == 1}">星客排行</div>
        </div>
        <div class="navi_bar_item" v-if="myTeamRank.teamNo"
             @click="navbarActiveIndex = 2">
          <div :class="{'active':navbarActiveIndex == 2}">战队排行</div>
        </div>
      </div>
      <div class="record_list">
        <div class="reward"
             v-if="navbarActiveIndex == 0 && rewardList"><!--  && rewardList.length > 0 -->
          <div class="thead">
            <table width="100%">
              <tr>
                <th align="left" class="name">星客名称</th>
                <th align="left">类型</th>
                <th align="right">贡献战力</th>
              </tr>
            </table>
          </div>
          <div class="scroll_wrap">
            <div class="reward_item" v-for="(item, index) in rewardList" :key="index">
              <img class="icon" :src="item.avatar && item.avatar.length > 0 ? item.avatar:picUrl.defaultImage">
              <div class="name">{{item.userName}}</div>
              <div class="time">{{item.prizeTime}}</div>
              <div class="type">{{popularizeMap[item.popularizeParticipantType]}}</div>
              <div v-if="item.isPositive" class="money">+{{item.amount}}</div>
              <div v-else class="money cancel">-{{item.amount}}</div>
            </div>
          </div>
        </div>
        <div class="share_order"
             v-else-if="navbarActiveIndex == 1 && prizeRecord && prizeRecord.length > 0">
          <div class="thead">
            <table width="100%">
              <tr>
                <th align="left" class="rank_name">星客名称</th>
                <th align="right">战力值</th>
              </tr>
            </table>
          </div>
          <div class="scroll_wrap">
            <div class="share_order_item"
                 v-for="(item, index) in prizeRecord"
                 :key="index">
              <div class="rank" :class="'top' + (index + 1)">{{index + 1}}</div>
              <img class="icon"
                   :src="item.avatar && item.avatar.length > 0?item.avatar:picUrl.defaultImage"
                   alt="">
              <div class="name">{{item.userName}}</div>
              <div class="time">已获得<span>{{item.shareTimes}}</span>位好友力挺</div>
              <div class="money">{{item.totalBountyShort}}</div>
            </div>
          </div>
          <div class="empty_line"></div>
        </div>
        <div class="team_rank"
             v-else-if="navbarActiveIndex == 2 && myTeamRank.teamNo">
          <div class="my_team">
            <div class="title">我的战队</div>
            <div class="tbody">
              <table width="100%">
                <tr class="team_rank_item">
                  <td class="item_rank"><i class="icon_rank" :class="'top' + myTeamRank.teamRank">{{myTeamRank.teamRank}}</i></td>
                  <td>
                    <p class="item_name">{{myTeamRank.teamName}}</p>
                    <p class="item_number">战队人数：{{myTeamRank.teamCount}}人 战力：{{myTeamRank.teamPower}}</p>
                  </td>
                  <td class="item_enter"><router-link :to="{path: 'myTeam', query: {popularizeNo: popularizeNo}}" class="team_enter">进入</router-link></td>
                </tr>
              </table>
            </div>
          </div>
          <div class="thead">
            <table width="100%">
              <tr>
                <th class="item_rank">排名</th>
                <th align="left">战队名称</th>
                <th width="20%">战力值</th>
              </tr>
            </table>
          </div>
          <div class="scroll_wrap">
            <div class="tbody">
              <table width="100%">
                <tr class="team_rank_item" v-for="(item, index) in teamRankList" :key="index">
                  <td class="item_rank"><i class="icon_rank" :class="'top' + item.teamRank">{{item.teamRank}}</i></td>
                  <td>
                    <p class="item_name">{{item.teamName}}</p>
                    <p class="item_number">战队人数：{{item.teamCount}}人</p>
                  </td>
                  <td class="item_value">{{item.teamPower}}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="empty"
             v-else>
          <div>暂无访问记录</div>
        </div>
      </div>
    </div>
    <div class="tab_bar"
         v-if="deviceType === 0">
      <div class="tab_bar_item"
           @click="navigateToIndex">
        <img :src="picUrl.tabTaskSel"
             alt="">
        <span class="active">星任务</span>
      </div>
      <div class="tab_bar_item"
           @click="navigateToMine">
        <img :src="picUrl.tabMeDef"
             alt="">
        <span>我的星球</span>
      </div>
    </div>
    <div id="share_alert"
         v-if="isShowRule || isShowShare"
         @click.stop="showRule(false)"></div>
    <div v-if="isShowRule"
         @click.stop="showRule(false)">
      <!--<img class="share_light"-->
      <!--:src="picUrl.shareLight"-->
      <!--alt="">-->
      <div class="light_red_rectangle">
        <div class="white_rectangle">
          <div class="scroll_inner"
               v-if="showFirendUsedTicketType == 'none'">
            <div v-for="(item, index) in popularizeList"
                 :key="index">
              <div v-if="popularizeDesc[item.type]"
                   class="alert_line">
                <img class="left"
                     :src="item.icon"
                     alt="">
                <div class="right">
                  <h3>{{item.title}} <span v-if="item.type == 'READ' || item.type == 'ENROLL' || item.type == 'WATCH_LIVE'">（{{popularizeDesc[item.type].endTime}}截止）</span></h3>
                  <p v-if="item.type == 'ORDER' && popularizeDesc[item.type].payConfigRemark">{{popularizeDesc[item.type].payConfigRemark}}</p> <!-- 下单支付方式奖励描述 -->
                  <p>
                    {{item.oneLine}}
                    <span v-if="item.type == 'ORDER'">
                      <span class="red">{{popularizeDesc[item.type].m}}</span>
                      元奖励
                    </span>
                    <span v-if="popularizeDesc[item.type].rule == 'FIX'"><span class="red">{{popularizeDesc[item.type].x}}</span> 元</span>
                    <span v-else-if="popularizeDesc[item.type].rule == 'PROPORTION'">实付额的 <span class="red">{{popularizeDesc[item.type].x}}%</span></span>
                    <span v-else><span class="red">{{popularizeDesc[item.type].x}}</span> ~ <span class="red">{{popularizeDesc[item.type].y}}</span> 元</span>
                    <span v-if="popularizeDesc[item.type].z != 0">( <span class="red">{{popularizeDesc[item.type].z}}</span>元封顶 ）</span>
                    <span v-else>（不封顶）</span>
                  </p>
                  <p v-if="item.type == 'READ'">限好友首次阅读本活动可获得奖励</p>
                  <p v-if="item.type == 'WATCH_LIVE'">限好友首次观看本直播<span class="red">{{popularizeDesc[item.type].watchTime}}</span>秒可获得奖励</p>
                  <div v-if="item.type == 'USE_COUPON' ||item.type == 'SIGN_IN'"
                       class="read">
                    <p>好友使用：</p>
                    <div @click.stop="showFirendTicket(item.type)">查看券</div>
                  </div>
                  <p v-if="item.type == 'ORDER' && popularizeDesc[item.type].b">单笔<span class="red">{{popularizeDesc[item.type].b}}</span>元封顶</p>
                  <p v-if="(item.type == 'ORDER'||item.type == 'USE_COUPON')&& popularizeDesc[item.type].freeze != 0">{{item.title}}冻结<span class="red">{{popularizeDesc[item.type].freeze}}</span>天</p>
                  <div v-if="popularizeDesc[item.type].z != 0"
                       class="progress">
                    <p>{{item.twoLine}}</p>
                    <div class="progress_line">
                      <div class="progress_in"
                           :style="{'width': popularizeDesc[item.type].progress+'%'}"></div>
                    </div>
                    <p class="red">{{popularizeDesc[item.type].progress}}%</p>
                  </div>
                  <h4 v-if="popularizeDesc[item.type].areaDetail&&item.type == 'READ'">{{popularizeDesc[item.type].areaDetail}}</h4>
                </div>
              </div>
            </div>
            <div class="white_back_box"></div>
          </div>
          <div v-else>
            <div class="alert_coupon_list"
                 v-if="popularizeDesc[showFirendUsedTicketType]">
              <div class="coupon_header"
                   @click.stop="showFirendTicket('none')">
                <img :src="picUrl.backIcon"
                     alt="">
                <div>好友用券</div>
              </div>
              <div class="coupon_content">
                <div class="scroll_inner">
                  <div class="coupon_item"
                       v-for="(item, index) in popularizeDesc[showFirendUsedTicketType].couponNames"
                       :key="index">{{item}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <img class="share_title"
           :src="popularizeImage&&popularizeImage.length > 0?popularizeImage:picUrl.shareTitle"
           alt=""> -->
      <div class="red_rectangle"
           v-if="deviceType === 0"
           @click.stop="showRule(false)">
        <p>温馨提示：链接分享给自己无法获得奖励</p>
        <div class="golden_btn">好的</div>
      </div>
    </div>
    <!-- <div class="share_firend"
         v-if="isShowShare">
      <img :src="picUrl.shareRightTop"
           alt="">
      <p>点击右上角分享给好友</p>
    </div> -->

    <div class="team_guide" v-if="!teamGuideHistory && teamGuide > 0">
      <img :src="picUrl.teamGuide1" v-if="teamGuide === 1" @click="teamGuide++">
      <img :src="picUrl.teamGuide2" v-if="teamGuide === 2" @click="teamGuide++">
      <img :src="picUrl.teamGuide3" v-if="teamGuide === 3" @click="teamGuide = 0">
    </div>

    <!--分享html，用于生成图片-->
    <div id="shareHtml">
      <div class="box">
        <div class="head">
          <div class="avatar"><img :src="shareInfo.avatar"
                 alt=""></div>
          <h3>好友{{shareInfo.nickName}}</h3>
          <p>邀请你一起参加</p>
        </div>
        <div class="body">
          <div class="bannerImg">
            <img :src="shareInfo.backgroundUrl"
                 alt="">
          </div>
          <div class="lineMiddle"></div>
          <div class="qrcodeBox">
            <div id="qrcode"
                 style="width: 150px;"></div>
            <p>请长按二维码参与活动</p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isShowSharePoster"
         class="sharePoster"><img :src="sharePoster"
           alt="">
      <p>长按保存图片邀请好友</p>
    </div>
    <div v-show="isShowSharePoster"
         class="sharePosterMask"
         @click="closeSharePoster"></div>
  </div>
</template>

<script>
import { floatMul, jsonDateFormat, appShareClick, getShortStringByLength } from '@/utils/index.js'
import barrage from '@/components/barrage'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
export default {
  name: 'activityShare',
  data () {
    return {
      picUrl: {
        shareBox: this.$store.state.ossLink + 'share/get_money_box_new.png',
        shareBack: this.$store.state.ossLink + 'share/share_back.png',
        shareFlag: this.$store.state.ossLink + 'share/share_bg4.png',
        tabTaskDef: this.$store.state.ossLink + 'icon_task_def.png',
        tabTaskSel: this.$store.state.ossLink + 'icon_task_sel.png',
        tabMeDef: this.$store.state.ossLink + 'icon_me_def.png',
        tabMeSel: this.$store.state.ossLink + 'icon_me_sel.png',
        shareQuestion: this.$store.state.ossLink + 'share/share_icon_explain.png',
        shareBtn: this.$store.state.ossLink + 'share/share_btn.png',
        shareMoney: this.$store.state.ossLink + 'share/share_icon_money.png',
        shareRightTop: this.$store.state.ossLink + 'share/ass_right_top.png',
        defaultImage: 'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/cimen/share.png',
        shareLight: this.$store.state.ossLink + 'activity/share_light.png',
        backIcon: this.$store.state.ossLink + 'share/share_one_btn_back-left.png',
        shareTitle: this.$store.state.ossLink + 'activity/demo_header.png',
        teamGuide1: this.$store.state.ossLink + 'share/team-guide-1.png',
        teamGuide2: this.$store.state.ossLink + 'share/team-guide-2.png',
        teamGuide3: this.$store.state.ossLink + 'share/team-guide-3.png'
      },
      shareBtnUrl: '', // 分享按钮图片
      navbarActiveIndex: 0,
      rewardList: [],
      isShowRule: false,
      myAccount: {},
      prizeRecord: [],
      popularizeMap: {
        ENROLL: '报名',
        ORDER: '下单',
        USE_COUPON: '用券',
        READ: '阅读',
        SIGN_IN: '签到',
        RETURN_COUPON: '退券',
        ALTER_ORDER: '改单',
        CANCEL_ORDER: '退单',
        WATCH_LIVE: '观看直播'
      },
      isShowShare: false,
      isShowBarrage: false,
      showFirendUsedTicketType: 'none', // 是否展示好友用券
      barrageArr: [],
      popularizeList: [
        { icon: this.$store.state.ossLink + 'share/share_one_icon_read.png', type: 'READ', title: '好友阅读奖励', oneLine: '好友阅读奖励', twoLine: '阅读奖励' },
        { icon: this.$store.state.ossLink + 'share/share_one_icon_bm.png', type: 'ENROLL', title: '好友报名奖励', oneLine: '好友报名奖励', twoLine: '报名奖励' },
        { icon: this.$store.state.ossLink + 'share/share_one_icon_sign.png', type: 'SIGN_IN', title: '好友签到奖励', oneLine: '好友签到奖励', twoLine: '签到奖励' },
        { icon: this.$store.state.ossLink + 'share/share_one_icon_quan.png', type: 'USE_COUPON', title: '好友用券奖励', oneLine: '好友报名购券并到店使用奖励', twoLine: '用券奖励' },
        { icon: this.$store.state.ossLink + 'share/share_one_icon_xiadan.png', type: 'ORDER', title: '好友下单奖励', oneLine: '好友报名后下单实付满', twoLine: '下单奖励' },
        { icon: this.$store.state.ossLink + 'share/share_one_icon_live.png', type: 'WATCH_LIVE', title: '好友观看直播奖励', oneLine: '好友观看直播奖励', twoLine: '观看直播奖励' }
      ],
      popularizeImage: '', // 推广头图
      popularizeDesc: {}, // 推广详情
      shareLink: '', // 分享链接
      nowActivityType: 0, // 当前活动状态 0 进行中 1 未开始 2 已结束
      shareInfo: {}, // 分享内容
      sharePoster: '', // 分享海报
      isShowSharePoster: false,
      deviceType: 0, // 设备类型
      teamGuide: 0, // 战队指引
      myTeamRank: { // 我的战队排行信息
        teamCount: 0, // 战队人数
        teamName: '', // 战队名称
        teamNo: '', // 战队编号
        teamPower: 0, // 战队战力
        teamRank: 0 // 战队排名
      },
      teamRankList: [] // 战队排行
    }
  },
  computed: {
    popularizeNo () {
      return localStorage.getItem('STAR_GUEST_POPULARIZENO')
    },
    teamGuideHistory () { // 是否指引 true看过，不显示  false没看过
      if (localStorage.getItem('teamGuideHistory')) {
        return true
      } else {
        localStorage.setItem('teamGuideHistory', '1')
        return false
      }
    }
  },
  components: {
    barrage
  },
  methods: {
    pushRecordNo () { // 推一下统计
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/add/push/record/no',
          params: {
            sourceType: localStorage.getItem('saleOrgType'),
            sourceNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 点击邀请好友按钮
     */
    /* eslint-disable */
    clickShareBtn () {
      if (this.deviceType > 0) {
        // 平果
        appShareClick()
        return
      }
      /*这是点击按钮触发的点击事件，关于clipboard的使用就不再赘述了，上面介绍时已经讲述过，并且使用方法在官方文档上有*/
      let self = this;

      let clipboard = new this.$clipboard(".share_btn");
      clipboard.on('success', function () {
        console.log('复制成功！')
      });
      clipboard.on('error', function () {
        console.log('复制失败，请手动选择复制！')
      });
      // this.isShowShare = true
      /*setTimeout(() => {
        self.isShowShare = false
      }, 5000)*/
      console.log('点击分享')
      // if (this.sharePoster) { // 海报生成需要时间，有海报才能点击显示
        this.isShowSharePoster = true
      // }
    },
    /* eslint-enable */
    showRule (val) {
      this.isShowRule = val
      this.isShowShare = false
    },
    showFirendTicket (val) {
      this.showFirendUsedTicketType = val
    },
    clickFreezeBtn () {
      this.$weui.dialog({
        title: '提示',
        content: '冻结金额为好友成功下单奖励金额，冻结时间内不可以提现哦，解冻就可以提取到微信零钱包啦！',
        className: 'custom-classname',
        buttons: [{
          label: '知道了',
          type: 'primary',
          onClick: function () {
            console.log('ok')
          }
        }]
      })
    },
    shareWithdraw () {
      if (this.deviceType === 0) { this.$router.push('/withdraw') } else {
        this.$weui.dialog({
          title: '提示',
          content: '请至星客联盟我的星球提现',
          className: 'custom-classname',
          buttons: [{
            label: '知道了',
            type: 'primary',
            onClick: function () {
              console.log('ok')
            }
          }]
        })
      }
    },
    navigateToIndex () {
      this.$router.push('/activity')
    },
    navigateToMine () {
      this.$router.push('/mine')
    },
    /**
     * /h5/star/task/popularize/prize/desc
     * 星客联盟活动描述
     */
    starGuestPopularizeDesc () {
      console.log(localStorage.getItem('STAR_GUEST_TOKEN'))
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/popularize/prize/desc',
          params: {
            popularizeId: localStorage.getItem('STAR_GUEST_POPULARIZEID')
          }
        })
        .then(res => {
          if (res.success) {
            self.isShowShareAlert = true
            let obj = {}
            res.data.forEach(item => {
              item.endTime = jsonDateFormat(item.endTime, 'minute1')
              item.progress = Math.round((item.progress * 100) * 1000) / 1000
              self.popularizeImage = item.popularizeImage
              obj[item.configType] = item
            })
            self.popularizeDesc = obj
            self.isShowRule = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/account/share/obtain/my/account
     * 分享时候的某个推广活动个人账户信息
     */
    shareObtainMyAccount () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/share/obtain/my/account',
          params: {
            popularizeNo: localStorage.getItem('STAR_GUEST_POPULARIZENO')
          }
        })
        .then(res => {
          if (res.success) {
            res.data.myBountyTotal = floatMul(res.data.myBountyTotal, 100) // 实际值 * 100
            res.data.myFreezeTotal = floatMul(res.data.myFreezeTotal, 100) // 实际值 * 100
            res.data.remainAmount = floatMul(res.data.remainAmount, 100) // 实际值 * 100
            let nowTime = parseInt((new Date()).getTime() / 1000)
            let startTime = parseInt(res.data.popularizeStartTime)
            let endTime = parseInt(res.data.popularizeEndTime)
            if (startTime > nowTime) {
              self.nowActivityType = 1
            } else if (nowTime > endTime) {
              self.nowActivityType = 2
            } else {
              self.nowActivityType = 0
            }
            self.myAccount = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/participant/record/share/obtain/prize/record
     * 分享赚现金访问记录
     */
    getStarGuestParticipantRecordShare () {
      let self = this
      self.$fly
        .request({
          url: '/h5/star/alliance2/star/guest/participant/record/share/obtain/prize/record',
          params: {
            popularizeNo: localStorage.getItem('STAR_GUEST_POPULARIZENO'),
            pageNo: 1,
            pageSize: 9999
          }
        })
        .then(res => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.isPositive = item.amount > 0
              item.amount = floatMul(item.amount, 100) // 战力值 = 实际值 * 100
              let newuserName = item.userName && item.userName.length > 0 ? item.userName : '喜盈门会员'
              item.userName = getShortStringByLength(newuserName, 14)
              item.prizeTime = jsonDateFormat(item.prizeTime, 'minute1')
            })
            self.rewardList = res.data.list
            if (!self.rewardList || self.rewardList.length === 0) {
              self.navbarActiveIndex = 1
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/participant/record/reward/obtain/prize/record
     * 排行榜
     */
    getStarGuestParticipantRecordReward () {
      let self = this
      self.$fly
        .request({
          url: '/h5/star/alliance2/star/guest/participant/record/reward/obtain/prize/record',
          params: {
            popularizeNo: localStorage.getItem('STAR_GUEST_POPULARIZENO'),
            pageNo: 1,
            pageSize: 20
          }
        })
        .then(res => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.bounty = floatMul(item.totalBounty, 100)
              let newuserName = item.userName && item.userName.length > 0 ? item.userName : '喜盈门会员'
              item.userName = getShortStringByLength(newuserName, 14)
              item.nickName = newuserName
              item.totalBountyShort = floatMul(item.totalBounty, 100)
            })
            self.prizeRecord = res.data.list
            self.barrageArr = res.data.list
            self.isShowBarrage = false
            setTimeout(() => {
              self.isShowBarrage = true
            }, 1000)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/my/team/rank
     * 我的战队排行信息
     */
    getMyTeamRank () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/my/team/rank',
          params: {
            popularizeNo: localStorage.getItem('STAR_GUEST_POPULARIZENO')
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              res.data.teamPower = floatMul(res.data.teamPower, 100) // 战力值 = 实际值 * 100
              self.myTeamRank = res.data
              self.getTeamRank()
              self.teamGuide = 1 // 如果有战队则显示指引第一步
            } else {
              self.teamGuide = 2 // 如果没有战队则跳过指引第一步
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/team/rank
     * 战队排行信息
     */
    getTeamRank () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/team/rank',
          params: {
            popularizeNo: localStorage.getItem('STAR_GUEST_POPULARIZENO'),
            pageNo: 1,
            pageSize: 99
          }
        })
        .then(res => {
          if (res.success) {
            res.data.list.forEach(item => {
              item.teamPower = floatMul(item.teamPower, 100) // 战力值 = 实际值 * 100
            })
            self.teamRankList = res.data.list
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    wxShare (requestUrlNew) {
      let self = this
      let shareUrlNew = document.location.protocol + '//' + location.host + '/#/?saleOrgType=' + localStorage.getItem('share_saleOrgType') + '&saleOrgNo=' + localStorage.getItem('share_saleOrgNo') + '&activityId=' + localStorage.getItem('activityId') + '&clerkId=' + localStorage.getItem('share_clerkId')
      let shareUrl = shareUrlNew
      self.shareLink = requestUrlNew
      let shareTitle = localStorage.getItem('STAR_ACTIVITY_SHARE_TITLE')
      let shareText = localStorage.getItem('STAR_ACTIVITY_SHARE_TEXT')
      let shareImage = localStorage.getItem('STAR_ACTIVITY_SHARE_IMAGE')
      self.$fly
        .request({
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: location.href.split('#')[0]
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'showMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage'
              ]
            })
            self.$wx.ready(function () {
              self.$wx.hideAllNonBaseMenuItem()
              self.$wx.showMenuItems({
                menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
              })
              self.$wx.updateAppMessageShareData({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                },
                fail: function () {
                  self.$wx.onMenuShareAppMessage({
                    title: shareTitle, // 分享标题
                    desc: shareText, // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareImage, // 分享图标
                    success: function () {
                      // 设置成功
                    },
                    fail: function () {
                      window.location.reload()
                    }
                  })
                }
              })
              self.$wx.updateTimelineShareData({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
              self.$wx.onMenuShareTimeline({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 用户点击了分享后执行的回调函数
                }
              })
              self.$wx.onMenuShareAppMessage({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getShareInfo () { // 获取分享海报的内容
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/share/to/picture',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
          }
        })
        .then(res => {
          if (res.success) {
            self.sharePoster = res.data.posterUrl
            self.wxShare(res.data.qrCodeUrl)
            // self.qrcode(res.data.qrCodeUrl) // 生成二维码链接
            // /* 0.5秒后生成海报 */
            // setTimeout(() => {
            //   self.htmlToImage()
            // }, 500)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    qrcode (qrUrl) { // 生成二维码链接
      /* eslint-disable */
      document.querySelector('#qrcode').innerHTML = ""
      new QRCode('qrcode', {
        width: 150,
        height: 150,
        text: qrUrl, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    htmlToImage () {
      let self = this
      // 注意：  allowTaint: true  和 useCORS: true 不能同时设置，两者只有一个起作用
      let htmlDom = document.querySelector('#shareHtml')
      html2canvas(htmlDom, {
        allowTaint: false, // 允许污染
        taintTest: true, // 在渲染前测试图片(没整明白有啥用)
        useCORS: true, // 使用跨域(当allowTaint为true时这段代码没什么用,下面解释)
        background: '#fff'
      }).then(function (canvas) {
        self.sharePoster = canvas.toDataURL('image/jpeg', 1.0)
      })
    },
    closeSharePoster () { // 关闭海报
      this.isShowSharePoster = false
    }
  },
  mounted () { },
  activated () {
    console.log(this.$route.query)
    let self = this
    self.myTeamRank = { // 我的战队排行信息
      teamCount: 0, // 战队人数
      teamName: '', // 战队名称
      teamNo: '', // 战队编号
      teamPower: 0, // 战队战力
      teamRank: 0 // 战队排名
    }
    self.teamRankList = [] // 战队排行
    self.deviceType = parseInt(localStorage.getItem('USER_DEVICE_TYPE'))
    if (self.$route.query.token) {
      localStorage.setItem('STAR_GUEST_TOKEN', self.$route.query.token)
    }
    if (self.$route.query.popularizeNo) {
      localStorage.setItem('STAR_GUEST_POPULARIZENO', self.$route.query.popularizeNo)
    }
    if (self.$route.query.popularizeId) {
      localStorage.setItem('STAR_GUEST_POPULARIZEID', self.$route.query.popularizeId)
    }
    this.showFirendUsedTicketType = 'none'
    this.pushRecordNo()
    this.starGuestPopularizeDesc()
    this.shareObtainMyAccount()
    this.getStarGuestParticipantRecordReward()
    this.getMyTeamRank()
    this.getStarGuestParticipantRecordShare()
    if (this.deviceType === 0) {
      this.getShareInfo()
      this.shareBtnUrl = self.$store.state.ossLink + 'share/share_btn_new.png?v=20191020'
    } else {
      this.shareBtnUrl = self.$store.state.ossLink + 'share/share_btn.png?v=20191020'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
#activityShare {
  width: 100%;
}
.top_view {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 930px;
  .share_back {
    width: 100%;
  }
  .share_flag {
    position: absolute;
    left: calc(50% - 210px);
    top: 14px;
    width: 420px;
    height: 66px;
  }
  .share_flag_text {
    position: absolute;
    left: calc(50% - 255px);
    top: 14px;
    width: 510px;
    height: 66px;
    line-height: 66px;
    text-align: center;
    font-size: 28px;
    color: #f6e7c4;
  }
  .share_rule_view {
    position: absolute;
    right: 0;
    height: 100px;
    width: 100px;
    top: 0;
  }
  .content_box {
    position: absolute;
    left: 81px;
    top: 110px;
    width: calc(100% - 162px);
    .share_box {
      width: 100%;
    }
    .share_ques {
      position: absolute;
      right: 50px;
      top: 178px;
      width: 30px;
      height: 30px;
    }
    .reward_money {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      top: 50px;
      font-size: 48px;
      color: #ff000c;
      span {
        display: block;
        font-size: 28px;
        line-height: 50px;
      }
    }
    .freeze_money {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      top: 187px;
      line-height: 25px;
      font-size: 26px;
      color: #666666;
      span {
        color: #ff000c;
      }
    }
    .share_withdraw {
      position: absolute;
      right: 20px;
      top: 50px;
      width: 100px;
      height: 50px;
      line-height: 50px;
      color: #e2342f;
      text-align: right;
      background: #f5e3be;
      font-size: 26px;
      -webkit-border-radius: 50px 0 0 50px;
      -moz-border-radius: 50px 0 0 50px;
      border-radius: 50px 0 0 50px;
    }
    .share_btn {
      position: absolute;
      width: 488px;
      top: 280px;
      left: 50%;
      margin-left: -244px;
    }
    .share_btn_disable {
      position: absolute;
      width: 484px;
      top: 280px;
      left: calc(50% - 242px);
      background: #999;
      height: 98px;
      line-height: 98px;
      text-align: center;
      font-size: 32px;
      color: #ffffff;
      border-radius: 10px;
    }
    .toActivityList{
      position: absolute;
      bottom: 10px;
      left: 0;
      width: 100%;
      text-align: center;
      a{
        display: inline-block;
        line-height: 63px;
        font-size: 24px;
        color: #f6dca3;
      }
    }
  }
}
.record {
  position: fixed;
  left: 0;
  width: 100%;
  top: 577px;
  bottom: 100px;
  background-color: #fefcf2;
  overflow: hidden;
  border-radius: 20px 20px 0px 0px;
  .navi_bar {
    position: absolute;
    top: 0;
  }
  .record_list {
    position: absolute;
    top: 100px;
    left: 0;
    width: 100%;
    bottom: 0;
    /* overflow-y: scroll;
    -webkit-overflow-scrolling: touch; */
    table{
      border-collapse: collapse;
    }
    .thead{
      height: 60px;
      line-height: 60px;
      color: #7c4d1f;
      background: #fefcf2;
      padding: 0 18px;
      .name{
        width: 397px;
        padding-left: 20px;
      }
    }
    .scroll_wrap{
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }
    .reward {
      height: 100%;
      .scroll_wrap{
        height: calc(100% - 60px);
      }
      .reward_item {
        margin: 0 18px;
        position: relative;
        height: 140px;
        border-bottom: 1px solid #fbf2dc; /* no */
        background: #fff;
        .icon {
          position: absolute;
          left: 20px;
          top: 35px;
          width: 66px;
          height: 66px;
          border-radius: 50%;
        }
        .name {
          position: absolute;
          left: 109px;
          width: 280px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          top: 35px;
          font-size: 28px;
          line-height: 28px;
          color: #7c4d1f;
        }
        .time {
          position: absolute;
          left: 106px;
          top: 79px;
          font-size: 26px;
          line-height: 26px;
          color: #bf804e;
        }
        .type {
          position: absolute;
          left: 417px;
          top: 55px;
          font-size: 28px;
          line-height: 28px;
          color: #bf804e;
        }
        .money {
          position: absolute;
          right: 3px;
          top: 55px;
          font-size: 28px;
          line-height: 28px;
          color: #bf804e;
        }
        .cancel {
          color: #1ed7b2;
        }
      }
    }
    .share_order {
      height: 100%;
      .scroll_wrap{
        height: calc(100% - 60px);
      }
      .thead{
        padding: 0 30px;
        th.rank_name{
          padding-left: 50px;
        }
      }
      .share_order_item {
        margin-left: 20px;
        width: calc(100% - 40px);
        position: relative;
        height: 140px;
        border-bottom: 1px solid #fbf2dc; /* no */
        background: #fff;
        .rank{
          position: absolute;
          left: 0;
          top: 35px;
          width: 60px;
          height: 66px;
          line-height: 66px;
          text-align: center;
          font-size: 28px;
          color: #999;
          font-weight: bold;
        }
        .rank.top1{
          color: #E51C23;
        }
        .rank.top2{
          color: #F25F23;
        }
        .rank.top3{
          color: #FF9800;
        }
        .icon {
          position: absolute;
          left: 60px;
          top: 35px;
          width: 66px;
          height: 66px;
          border-radius: 50%;
        }
        .name {
          position: absolute;
          left: 169px;
          width: calc(100% - 320px);
          top: 32px;
          font-size: 28px;
          line-height: 34px;
          color: #7c4d1f;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .time {
          position: absolute;
          left: 169px;
          top: 79px;
          font-size: 26px;
          line-height: 26px;
          color: #bf804e;
          span{
            color: #ff000c;
          }
        }
        .money {
          position: absolute;
          right: 22px;
          top: 35px;
          line-height: 66px;
          font-size: 28px;
          color: #bf804e;
          font-weight: bold;
        }
        .share_money {
          position: absolute;
          right: 22px;
          top: 25px;
          width: 36px;
          height: 36px;
        }
      }
    }
    .team_rank{
      height: 100%;
      .tbody{
        padding: 0 18px;
      }
      .my_team{
        height: 160px;
        padding: 20px 0;
        box-sizing: border-box;
        .title{
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          font-size: 26px;
          color: #7c4d1f;
          font-weight: bold;
        }
        .team_rank_item td{
          border: none;
        }
      }
      .scroll_wrap{
        height: calc(100% - 220px);
      }
      th.item_rank{
        width: 100px;
      }
      .team_rank_item{
        td{
          height: 80px;
          padding: 10px 0;
          background: #fff;
          border-bottom: solid 1px #fbf2dc;
          .icon_rank{
            display: block;
            width: 60px;
            height: 60px;
            line-height: 60px;
            margin: 0 20px;
            color: #7c4d1f;
            text-align: center;
            font-size: 24px;
            font-style: normal;
            font-weight: bold;
            background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-gray.png');
            background-repeat: no-repeat;
            background-position: center center;
            -webkit-background-size: cover;
            background-size: cover;
          }
          .icon_rank.top1{
            background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top1.png');
          }
          .icon_rank.top2{
            background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top2.png');
          }
          .icon_rank.top3{
            background-image: url('https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon-rank-top3.png');
          }
          .item_name{
            color: #7c4d1f;
            line-height: 34px;
          }
          .item_number{
            line-height: 34px;
            color: #bf804e;
          }
          .team_enter{
            display: block;
            width: 110px;
            height: 46px;
            line-height: 46px;
            border: solid 2px #E51C23;
            color: #E51C23;
            text-align: center;
            -webkit-border-radius: 46px;
            -moz-border-radius: 46px;
            border-radius: 46px;
          }
        }
        td.item_rank{
          width: 100px;
        }
        td.item_enter{
          width: 20%;
        }
        td.item_value{
          font-size: 32px;
          padding: 0 30px;
          text-align: right;
          color: #bf804e;
        }
      }
    }
    .empty {
      margin-top: 145px;
      text-align: center;
      width: 100%;
      color: #999999;
    }
  }
}
#share_alert {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  background-color: #000000;
  opacity: 0.7;
}
.share_light {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99999;
  width: 100%;
}
.light_red_rectangle {
  position: fixed;
  top: 152px;
  left: 45px;
  z-index: 99999;
  width: calc(100% - 90px);
  height: 891px;
  background-image: linear-gradient(0deg, #de322e 0%, #fe5f5e 100%),
    linear-gradient(#ffffff, #ffffff);
  background-blend-mode: normal, normal;
  border-radius: 10px;
  .white_rectangle {
    position: absolute;
    top: 64px;
    left: 14px;
    width: calc(100% - 28px);
    background-color: #ffffff;
    border-radius: 10px;
    height: 827px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .white_back_box {
      width: 100%;
      height: 170px;
    }
    .alert_line {
      overflow: hidden;
      padding-top: 30px;
      padding-bottom: 20px;
      border-bottom: #cccccc 1px solid; /* no */
      .left {
        margin-left: 27px;
        width: 66px;
        height: 66px;
        display: block;
        float: left;
      }
      .right {
        margin-left: 24px;
        width: calc(100% - 120px);
        display: block;
        float: left;
        h3 {
          font-size: 28px;
          color: #333333;
        }
        p {
          font-size: 24px;
          color: #7c4d1f;
        }
        h4 {
          font-size: 24px;
          color: #000000;
        }
        .red {
          color: #ff000c;
        }
        .read {
          overflow: hidden;
          p {
            display: block;
            float: left;
          }
          div {
            display: block;
            float: left;
            width: 74px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border-radius: 15px;
            border: solid 1px #ff000c; /* no */
            font-size: 16px;
            color: #ff000c;
          }
        }
        .progress {
          overflow: hidden;
          p {
            display: block;
            float: left;
            margin-right: 5px;
          }
          .red {
            color: #ff000c;
          }
          .progress_line {
            display: block;
            float: left;
            background: #fcefdf;
            width: 100px;
            margin-top: 10px;
            height: 18px;
            border-radius: 19px;
            overflow: hidden;
            position: relative;
            .progress_in {
              position: absolute;
              left: 0;
              top: 0;
              background: #ff000c;
              width: 20%;
              height: 18px;
            }
          }
        }
      }
    }
    .coupon_header {
      height: 100px;
      width: 100%;
      border-bottom: #f7f7f7 1px solid; /* no */
      img {
        display: block;
        float: left;
        width: 16px;
        height: 30px;
        margin-left: 28px;
        margin-top: 35px;
      }
      div {
        margin-left: 38px;
        display: block;
        float: left;
        line-height: 100px;
        height: 100px;
        font-size: 34px;
        color: #333333;
      }
    }
    .coupon_content {
      width: 100%;
      height: 580px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .coupon_item {
        height: 88px;
        width: calc(100% - 56px);
        line-height: 88px;
        padding: 0 28px;
        font-size: 28px;
        color: #333333;
        border-bottom: #f7f7f7 1px solid; /* no */
      }
    }
  }
}
.share_title {
  position: fixed;
  top: 0;
  width: 100%;
  height: 300px;
  left: 0;
  z-index: 99999;
}
.red_rectangle {
  position: fixed;
  top: 890px;
  left: 30px;
  width: calc(100% - 60px);
  height: 154px;
  background-image: linear-gradient(0deg, #da2a21 0%, #ff0600 100%),
    linear-gradient(#f6dca3, #f6dca3);
  background-blend-mode: normal, normal;
  border-radius: 10px;
  z-index: 99999;
  p{
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f6dca3;
  }
  .golden_btn {
    position: absolute;
    top: 50px;
    left: calc(50% - 237px);
    width: 474px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    background-color: #f6dca3;
    border-radius: 10px;
    font-family: PingFang-SC-Bold;
    font-size: 32px;
    color: #ff000c;
  }
}
.rule_detail {
  position: fixed;
  top: 25%;
  height: 50%;
  left: 14%;
  width: 72%;
  z-index: 99999;
  background: #fff;
  border-radius: 10px;
  .rule_btn {
    color: #f6e6c3;
    position: absolute;
    bottom: 14px;
    height: 72px;
    line-height: 72px;
    text-align: center;
    left: calc(50% - 200px);
    width: 400px;
    font-size: 32px;
    border-radius: 36px;
    background-image: linear-gradient(90deg, #ffb700 0%, #ff3833 100%),
      linear-gradient(#ffffff, #ffffff);
  }
  .rule_title {
    color: #000;
    font-family: PingFangSC-Medium;
    position: absolute;
    top: 20px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    width: 100%;
    font-size: 32px;
  }
  .rule_main {
    position: absolute;
    left: 40px;
    width: calc(100% - 80px);
    top: 100px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 200px);
    .rule_detail_inner {
      min-height: calc(100% + 1px);
      font-size: 30px;
    }
  }
}
.share_firend {
  img {
    position: fixed;
    right: 5%;
    top: 5%;
    width: 45%;
    z-index: 999999;
  }
  p {
    position: fixed;
    left: 0;
    width: 100%;
    color: #fff;
    top: 30%;
    text-align: center;
    font-size: 50px;
    z-index: 999999;
  }
}
.empty_line {
  width: 100%;
  height: 100px;
}
#shareHtml {
  width: 750px;
  height: 1334px;
  .box {
    width: 750px;
    height: 1334px;
    background-color: red;
    background-image: linear-gradient(135deg, red, yellow);
    .head {
      padding: 38px 0 36px;
      text-align: center;
      color: #fff;
      .avatar {
        img {
          width: 105px;
          height: 105px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
        }
      }
    }
    .body {
      width: 685px;
      height: 1028px;
      margin: 0 auto;
      background: url(data:image/png;base64,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);
      -webkit-background-size: 100% 100%;
      background-size: 100% 100%;
      .bannerImg {
        padding: 18px 0 20px;
        text-align: center;
        img {
          width: 645px;
          height: 516px;
        }
      }
      .lineMiddle {
        height: 20px;
      }
      .qrcodeBox {
        padding: 40px 0;
        text-align: center;
        #qrcode {
          margin: 0 auto 20px;
        }
        p {
          font-size: 28px;
        }
      }
      img {
        max-width: 100%;
      }
    }
  }
}
.sharePoster {
  position: fixed;
  left: 50%;
  top: 100px;
  width: 500px;
  margin-left: -250px;
  z-index: 10001;
  img {
    max-width: 100%;
  }
  p {
    color: #fff;
    text-align: center;
  }
}
.sharePosterMask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
}
.team_guide{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activity/share.vue